import React from 'react';
import AppLayout from '../../components/AppLayout';
import {PageMenu,AddListItem,LoadGraphic,Step} from '../../components/Common';
import {Input,Button,TextButton, MiniMinusButton,
        Checkbox,PageSelector,Box,Date} from '../../components/Input';
import u from '../../utilities/Utilities';
import {DashboardAnalytic} from '../Dashboard';
import moment from 'moment';

export default class Store extends React.Component{
    
    r={}

    state={
        pageMenuButtons:[],
    }

    settings={
        /**** Page Setup ****/
        title:"Main Store",
        permission:"inventory",  //Accepts combined permission module as well
        //combinedField:"",     //Used when permission exists in a combined field
        url:"/store",
    }

    componentDidMount=()=>{
        const permissions=u.getPermissions("inventory");

        this.setState({
            permissions:permissions,
            pageMenuButtons:[
              {label:"Find Inventory",ref:"find",enabled:(permissions.view==2)},
              {label:"Transfer / Return",ref:"transfer",enabled:(permissions.update==2)},
              {label:"Dispose Condemned",ref:"dispose",enabled:(permissions.update==2)},
              {label:"Store Items",ref:"itemList",enabled:(permissions.create==2),onClick:this.onItemList},
              {label:"Store Activity",ref:"storeActivity",enabled:(permissions.create==2),onClick:this.onStoreActivity},
            ]
        });
    }

    onItemList=()=>{
        window.open("/store-item-list","_blank");
    }

    onStoreActivity=()=>{
        window.open("/store-activity","_blank");
    }
    
    render=()=>{
        const pageComponents={
            find:{component:FindInventory,props:{}},
            transfer:{component:TransferItem,props:{}},
            dispose:{component:DisposeItem,props:{}},
        };

        return(
            <AppLayout ref={(ref)=>{this.r["layout"]=ref}} 
                       settings={this.settings}
                       >
            
                <div className="page-error-container">
                    <div className="page-error">{this.state.error}</div>
                </div>

                <PageMenu ref={(ref)=>{this.r['pageMenu']=ref}}
                          settings={this.settings}
                          buttons={this.state.pageMenuButtons}
                          components={pageComponents}
                          selected={this.state.selected}
                          />
                
                <div>
                    <DashboardAnalytic getURL="/api/get-store-dashboard"
                                       overrideURL="/api/get-store-dashboard-content"
                                       noMenu={true}
                                       noSize={true}
                                       noDrag={true}
                                       />
                </div>

            </AppLayout>
        )
    }

}

class FindInventory extends React.Component{

    r={};

    state={
        step:"view",
        entryData:{
            dormID:"All",
            clusterID:"All",
            buildingID:"All",
            drawEntityType:"Inventory Location",
        },
        drawEntityType:[
            {value:"Inventory Location",label:"Inventory Location"},
            {value:"Staff",label:"Staff"},
            {value:"Room",label:"Room"},
        ],
        drawEntityOptions:[],
        estateOptions:{
            dormOptions:[],
            clusterOptions:[],
            buildingOptions:[]
        },
        loading:false,
        loadText:"",
    }

    componentDidMount=()=>{
        this.getEstateOptions(null,"dorm");
    }

    show=(show)=>{
        this.r[this.props.reference].show(show);
        if(!show){
            this.setState({error:""});
        }
    }

    onCancel=()=>{
        this.props.onToggleForm(this.props.reference,false);
    }

    onSetParams=(fields)=>{
        const keys = fields.map((item)=>{return item.field});
        let data = {};
        for(var i=0; i<keys.length; i++){
            if(this.r[keys[i]]){
                const current=this.r[keys[i]].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
                data[keys[i]]=current.value;
            }
        }
        window.open("/inventory/"+data.inventoryID,"_blank"); 
    }

    onComplete=()=>{
        this.setState({
            entryData:{
                dormID:"All",
                clusterID:"All",
                buildingID:"All",
                drawEntityType:"Inventory Location",
            },
            step:"view"
        });
    }

    getDrawEntity=async(entryData)=>{
        if(this.lastDraw?.dormID == entryData.dormID &&
           this.lastDraw?.clusterID == entryData.clusterID &&
           this.lastDraw?.buildingID == entryData.buildingID &&
           this.lastDraw?.drawEntityType == entryData.drawEntityType){
            return 0;
        }
        this.lastDraw={
            dormID:entryData.dormID,
            clusterID:entryData.clusterID,
            buildingID:entryData.buildingID,
            drawEntityType:entryData.drawEntityType,
        };
        try{
            const response=await u.postAsync({
                url:"/api/get-draw-entity-options",
                data:entryData
            });
            this.setState({drawEntityOptions:response.data});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error});
        }
    }

    getEstateOptions=async(id,type)=>{
        try{
            let {estateOptions}=this.state;
            const response=await u.postAsync({
                url:"/api/get-estate-options",
                data:{
                    type:type,
                    id:id,
                }
            });
            response.data.unshift({value:"All",label:"All"});
            estateOptions[type+"Options"]=response.data;
            this.setState({estateOptions:estateOptions});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error});
        }
    }

    onChange=(value,label,index,option)=>{
        console.log(value,label);
        let {entryData}=this.state;
        entryData[label]=value;
        if(label == "drawEntityType"){
            entryData["dormID"]="All";
            entryData["clusterID"]="All";
            entryData['buildingID']="All";
            this.getDrawEntity(entryData);
        }
        if(label == "dormID"){
            this.getEstateOptions(value,"cluster");
            entryData["clusterID"]="All";
            entryData['buildingID']="All";
            this.getDrawEntity(entryData);
        }
        else if(label == "clusterID"){
            this.getEstateOptions(value,"building");
            entryData['buildingID']="All";
            this.getDrawEntity(entryData);
        }
        else if(label == "buildingID"){
            this.getDrawEntity(entryData);
        }
        this.setState({entryData:entryData});
    }

    render=()=>{
        const {loading,loadText,step,estateOptions,drawEntityOptions,
               drawEntityType,entryData,action}=this.state;

        const drawType={
            "Inventory Location":[
                {dataType:"select",label:"Dormitory",field:"dormID",options:estateOptions.dormOptions},
                {dataType:"select",label:"Cluster",field:"clusterID",options:estateOptions.clusterOptions},
                {dataType:"select",label:"Building",field:"buildingID",options:estateOptions.buildingOptions},
                {dataType:"select",label:"Draw Entity (Inventory)",field:"inventoryID",options:drawEntityOptions},
            ],
            "Room":[
                {dataType:"select",label:"Dormitory",field:"dormID",options:estateOptions.dormOptions},
                {dataType:"select",label:"Cluster",field:"clusterID",options:estateOptions.clusterOptions},
                {dataType:"select",label:"Building",field:"buildingID",options:estateOptions.buildingOptions},
                {dataType:"select",label:"Draw Entity (Inventory)",field:"inventoryID",options:drawEntityOptions},
            ],
            "Staff":[
                {dataType:"select",label:"Draw Entity (Inventory)",field:"inventoryID",options:drawEntityOptions},
            ]
        };

        const fields=[
            {dataType:"select",label:"Draw Entity Type",field:"drawEntityType",options:drawEntityType},
        ].concat(drawType[entryData.drawEntityType]);

        return (
            <AddListItem ref={(ref)=>{this.r[this.props.reference]=ref}}
                         reference={this.props.reference}
                         settings={{}}
                         onComplete={this.onComplete}
                         uploadAsJson={false}
                         onToggleForm={this.props.onToggleForm}
                         action={action}
                         >

                <div className='segment-content'>
                    <LoadGraphic active={loading} text={loadText}/>
                    <Step active={step=="view"}>
                        <h3>Complete the following fields to continue</h3>
                        {
                            fields.map(
                                (item,index)=>{
                                    return (
                                        <Input key={index}
                                               ref={(ref)=>{this.r[item.field]=ref}}
                                               values={{
                                                    options:item.options,
                                                    value:entryData[item.field]
                                                }}
                                               fields={{
                                                 ...item,
                                                 onChange:this.onChange
                                               }}
                                               rules={item.rules}
                                               labelStyle={{width:"40%"}}
                                               inputStyle={{width:"57%"}}
                                               />
                                    )
                                }
                            )
                        }
                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={this.onCancel}>Cancel</Button>
                            <Button onClick={()=>{this.onSetParams(fields)}}>Confirm</Button>
                        </div>
                    </Step>     
                </div>
            </AddListItem>
        )
    }
}

class TransferItem extends React.Component{

    r={};

    state={
        step:"view",
        entryData:{
            dormID:"All",
            clusterID:"All",
            buildingID:"All",
            drawEntityType:"Inventory Location",
        },
        storeItems:[],
        activityType:[
            {value:"Transfer",label:"Transfer"},
            {value:"Return",label:"Return"},
        ],
        drawEntityType:[
            {value:"Inventory Location",label:"Inventory Location"},
            {value:"Staff",label:"Staff"},
            {value:"Room",label:"Room"},
        ],
        secondaryActivityType:[
            {value:"Condemn",label:"Condemn"},
            {value:"Missing",label:"Missing"},
        ],
        drawEntityOptions:[],
        estateOptions:{
            dormOptions:[],
            clusterOptions:[],
            buildingOptions:[]
        },
        interest:[],
        loading:false,
        loadText:"",
        inventoryItems:[],
        returnItems:[],
    }

    componentDidMount=()=>{
        this.getEstateOptions(null,"dorm");
    }

    show=(show)=>{
        this.r[this.props.reference].show(show);
        if(!show){
            this.setState({error:""});
        }
    }

    onCancel=()=>{
        this.props.onToggleForm(this.props.reference,false);
    }

    onSetParams=(fields)=>{
        const keys = fields.map((item)=>{return item.field});
        let data = {};
        for(var i=0; i<keys.length; i++){
            if(this.r[keys[i]]){
                const current=this.r[keys[i]].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
                data[keys[i]]=current.value;
            }
        }
        if(data.activityType == "Transfer"){
            this.getStoreItems(data.inventoryID);
        }
        else if(data.activityType == "Return"){
            this.getInventoryItems(data.inventoryID);
        }
        
        //this.r[this.props.reference].onValidated(data);
    }

    onComplete=()=>{
        this.setState({
            entryData:{
                dormID:"All",
                clusterID:"All",
                buildingID:"All",
                drawEntityType:"Inventory Location",
            },
            step:"view"
        });
    }

    getDrawEntity=async(entryData)=>{
        if(this.lastDraw?.dormID == entryData.dormID &&
           this.lastDraw?.clusterID == entryData.clusterID &&
           this.lastDraw?.buildingID == entryData.buildingID &&
           this.lastDraw?.drawEntityType == entryData.drawEntityType){
            return 0;
        }
        this.lastDraw={
            dormID:entryData.dormID,
            clusterID:entryData.clusterID,
            buildingID:entryData.buildingID,
            drawEntityType:entryData.drawEntityType,
        };
        try{
            const response=await u.postAsync({
                url:"/api/get-draw-entity-options",
                data:entryData
            });
            this.setState({drawEntityOptions:response.data});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error});
        }
    }

    getEstateOptions=async(id,type)=>{
        try{
            let {estateOptions}=this.state;
            const response=await u.postAsync({
                url:"/api/get-estate-options",
                data:{
                    type:type,
                    id:id,
                }
            });
            response.data.unshift({value:"All",label:"All"});
            estateOptions[type+"Options"]=response.data;
            this.setState({estateOptions:estateOptions});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error});
        }
    }

    onChange=(value,label,index,option)=>{
        console.log(value,label);
        let {entryData}=this.state;
        entryData[label]=value;
        if(label == "drawEntityType"){
            entryData["dormID"]="All";
            entryData["clusterID"]="All";
            entryData['buildingID']="All";
            this.getDrawEntity(entryData);
        }
        if(label == "dormID"){
            this.getEstateOptions(value,"cluster");
            entryData["clusterID"]="All";
            entryData['buildingID']="All";
            this.getDrawEntity(entryData);
        }
        else if(label == "clusterID"){
            this.getEstateOptions(value,"building");
            entryData['buildingID']="All";
            this.getDrawEntity(entryData);
        }
        else if(label == "buildingID"){
            this.getDrawEntity(entryData);
        }
        this.setState({entryData:entryData});
    }

    getStoreItems=async (inventoryID)=>{
        this.setState({loading:true,loadText:"Getting items"});
        try{
            const response = await u.postAsync({
                url:"/api/get-transferrable-store-items",
                data:{
                    inventoryID:inventoryID
                }
            });
            this.setState({storeItems:response.data,step:"choose-store-item",loading:false});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({loading:false,error:error});
        }
    }

    onConfirmStore=async ()=>{
        const interest = this.state.storeItems.filter((item)=>{
            return item.selected;
        }).map((item)=>{
            return item;
        });

        this.onConfirmInterest=async ()=>{
            try{
                const {interest,entryData}=this.state;
                const comp = this.r['confirm'].validate();
                if(!comp.valid){
                    this.setState({error:comp.value});
                    return 0;
                }

                this.r[this.props.reference].onValidated({
                    inventoryID:entryData.inventoryID,
                    items:interest
                });
            }
            catch(e){
                const {error,status}=u.processError(e);
                this.setState({error:error});
            }
        }

        this.setState({
            interest:interest,
            step:"confirm-store-item",
            error:"",
            confirmDisclaimer:false,
            action:"transferred"
        });
    }

    //Return
    getInventoryItems=async(inventoryID)=>{
      try{
        this.setState({loading:true,loadText:"Preparing..."});
        const response=await u.postAsync({
            url:"/api/get-inventory",
            data:{
                inventoryID:inventoryID
            }
        });
        this.setState({
            inventoryItems:response.data.items,
            inventory:response.data.attachedType + " - " + response.data.attachedLabel,
            step:"choose-inventory-item",
            error:"",
            loading:false,
        });
      } 
      catch(e){
        const {error,status}=u.processError(e);
        this.setState({error:error,loading:false});
      }  
    }

    onConfirmInventory=()=>{
        let {inventoryItems,entryData}=this.state;
        this.setState({
            returnItems:inventoryItems.filter((item)=>{
                return item.selected;
            }).map((item)=>{
                item.return=0;
                item.missing=0;
                item.condemned=0;
                return item;
            }),
            step:"confirm-inventory-item",
            action:"returned",
            confirmDisclaimer:false,
        });

        this.onConfirmReturned=async()=>{
            //Validate
            this.setState({error:""});
            const inv = this.r['confirm-inventory'].validate();
            if(!inv.valid){
                this.setState({error:inv.value});
                return 0;
            }
            this.r[this.props.reference].onValidated({
                inventoryID:entryData.inventoryID,
                items:inv.value
            });
        };
        
    }

    render=()=>{
        const {loading,loadText,step,estateOptions,drawEntityOptions,
               drawEntityType,activityType,entryData,storeItems,interest,
               confirmDisclaimer,inventoryItems,returnItems,action}=this.state;

        const drawType={
            "Inventory Location":[
                {dataType:"select",label:"Dormitory",field:"dormID",options:estateOptions.dormOptions},
                {dataType:"select",label:"Cluster",field:"clusterID",options:estateOptions.clusterOptions},
                {dataType:"select",label:"Building",field:"buildingID",options:estateOptions.buildingOptions},
                {dataType:"select",label:"Draw Entity (Inventory)",field:"inventoryID",options:drawEntityOptions},
            ],
            "Room":[
                {dataType:"select",label:"Dormitory",field:"dormID",options:estateOptions.dormOptions},
                {dataType:"select",label:"Cluster",field:"clusterID",options:estateOptions.clusterOptions},
                {dataType:"select",label:"Building",field:"buildingID",options:estateOptions.buildingOptions},
                {dataType:"select",label:"Draw Entity (Inventory)",field:"inventoryID",options:drawEntityOptions},
            ],
            "Staff":[
                {dataType:"select",label:"Draw Entity (Inventory)",field:"inventoryID",options:drawEntityOptions},
            ]
        };

        const fields=[
            {dataType:"select",label:"Activity Type",field:"activityType",options:activityType},
            {dataType:"select",label:"Draw Entity Type",field:"drawEntityType",options:drawEntityType},
        ].concat(drawType[entryData.drawEntityType]);

        return (
            <AddListItem ref={(ref)=>{this.r[this.props.reference]=ref}}
                         reference={this.props.reference}
                         settings={(entryData.activityType=="Transfer") ? {
                            addType:1,
                            addURL:"/api/create-store-item-transfer",
                            } : {
                            addType:1,
                            addURL:"/api/return-store-item",
                            }}
                         onComplete={this.onComplete}
                         uploadAsJson={false}
                         onToggleForm={this.props.onToggleForm}
                         action={action}
                         >

                <div className='segment-content'>
                    <LoadGraphic active={loading} text={loadText}/>
                    <Step active={step=="view"}>
                        <h3>Complete the following fields to continue</h3>
                        {
                            fields.map(
                                (item,index)=>{
                                    return (
                                        <Input key={index}
                                               ref={(ref)=>{this.r[item.field]=ref}}
                                               values={{
                                                    options:item.options,
                                                    value:entryData[item.field]
                                                }}
                                               fields={{
                                                 ...item,
                                                 onChange:this.onChange
                                               }}
                                               rules={item.rules}
                                               labelStyle={{width:"40%"}}
                                               inputStyle={{width:"57%"}}
                                               />
                                    )
                                }
                            )
                        }
                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={this.onCancel}>Cancel</Button>
                            <Button onClick={()=>{this.onSetParams(fields)}}>Confirm</Button>
                        </div>
                    </Step>

                    <Step active={step=="choose-store-item"}>
                        <h3>Select Items to Transfer</h3>
                        <CanDrawItem options={storeItems}
                                     onChange={(value)=>{this.setState({storeItems:value})}}
                                     />
                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button onClick={this.onConfirmStore}>Confirm</Button>
                        </div>
                    </Step>

                    <Step active={step=="confirm-store-item"}>
                        <h3>Input quantity for each transfer item</h3>
                        <ConfirmDrawItem ref={(ref)=>{this.r['confirm']=ref}}
                                         options={interest}
                                         onChange={(value)=>{this.setState({interest:value})}}/>

                        <div style={{position:"relative",fontSize:"14px",margin:"20px auto"}}>
                            <Checkbox values={{value:confirmDisclaimer}}
                                      onChange={(value)=>{this.setState({confirmDisclaimer:value})}}
                                      /> 
                            <span style={{marginLeft:"10px"}}>
                                Confirm that items transferred are accepted in good/servicable condition
                            </span>
                        </div>
                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button enabled={confirmDisclaimer==true} onClick={()=>{this.onConfirmInterest()}}>Confirm</Button>
                        </div>
                    </Step>

                    <Step active={step=="choose-inventory-item"}>
                        <h3>Select Items to Return</h3>
                        <SelectInventoryItem options={inventoryItems}
                                             onChange={(value)=>{this.setState({inventoryItems:value})}}
                                             />
                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button onClick={this.onConfirmInventory}>Confirm</Button>
                        </div>
                    </Step>

                    <Step active={step=="confirm-inventory-item"}>
                        <h3>Input quantity for each returned item</h3>
                        <ConfirmInventoryItem ref={(ref)=>{this.r['confirm-inventory']=ref}}
                                              options={returnItems}
                                              onChange={(value)=>{this.setState({returnItems:value})}}
                                              />

                        <div style={{position:"relative",fontSize:"14px",margin:"20px auto"}}>
                            <Checkbox values={{value:confirmDisclaimer}}
                                      onChange={(value)=>{this.setState({confirmDisclaimer:value})}}
                                      /> 
                            <span style={{marginLeft:"10px"}}>
                                Confirm that items not in servicable condition are either marked as Missing or Condemned
                            </span>
                        </div>
                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button enabled={confirmDisclaimer==true} onClick={()=>{this.onConfirmReturned()}}>Confirm</Button>
                        </div>
                    </Step>
                </div>
            </AddListItem>
        )
    }
}

export class SelectInventoryItem extends React.Component{
    r={};

    pageLength=10;

    state={
        page:1,
        startIndex:0,
        endIndex:this.pageLength,
    }

    onChangePage=(newPage)=>{
        const startIndex = (newPage-1) * this.pageLength;
        const endIndex = startIndex + this.pageLength;
        this.setState({page:newPage,startIndex:startIndex,endIndex:endIndex});
    }

    onSelectAll=(value)=>{
        let {options}=this.props;
        options=options.map((item)=>{
            item.selected=value;
            return item;
        });
        this.props.onChange(options);
    }

    onChange=(value,label,index)=>{
        let {options}=this.props;
        options[index].selected=value;
        this.props.onChange(options);
    }

    render=()=>{
        const {options}=this.props;
        const {page,startIndex,endIndex}=this.state;
        const maxPage = Math.ceil(options.length / this.pageLength);

        if(options.length == 0){
            return (
                <div className='list-placeholder'>
                    <b>No Items Available</b>
                </div>
            )
        }

        return (
            <div>
                <div className='list-table' style={{maxHeight:"none",fontSize:"14px"}}>
                    <table>
                        <thead>
                            <tr>
                                <th className='remove left'>
                                    <Checkbox values={{
                                                value:(options.filter((item)=>{return item.selected}).length == options.length),
                                                
                                            }}
                                            onChange={this.onSelectAll}
                                            label="Select All"
                                            />
                                </th>
                                <th>Item</th>
                                <th className='right' style={{width:"150px"}}>Drawn Quantity</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                options.map(
                                    (item,index)=>{
                                        if(index<startIndex || index>=endIndex){
                                            return null;
                                        }
                                        return (
                                            <tr key={index}>
                                                <td>
                                                    <Checkbox values={{value:item.selected}}
                                                            index={index}
                                                            label="Selected"
                                                            field="selected"
                                                            onChange={this.onChange}
                                                            />
                                                </td>
                                                <td>{item.itemCode} - {item.itemName}</td>
                                                <td>{item.quantity} {item.servingQuantifier}</td>
                                            </tr>
                                        )
                                    }
                                )
                            }
                        </tbody>
                    </table>
                </div>
                {
                    (maxPage>1)
                        ?
                        <div style={{position:"relative",fontSize:"12px",margin:"30px auto"}}>
                            <PageSelector maxPage={maxPage}
                                        page={page}
                                        onChange={this.onChangePage}
                                        />
                        </div>
                        :
                        null
                }
            </div>
        )
    }
}

export class ConfirmInventoryItem extends React.Component{
    r={};

    pageLength=10;

    state={
        page:1,
        startIndex:0,
        endIndex:this.pageLength,
    }

    onChangePage=(newPage)=>{
        const startIndex = (newPage-1) * this.pageLength;
        const endIndex = startIndex + this.pageLength;
        this.setState({page:newPage,startIndex:startIndex,endIndex:endIndex});
    }

    onChange=(value,label,index)=>{
        console.log(value,label,index);
        let {options}=this.props;
        options[index][label]=value;
        this.props.onChange(options);
    }

    validate=()=>{
        let {options}=this.props;
        const subkeys=["return","missing","condemned","reason"];
        for(var i=0; i<options.length; i++){
            let total=0;
            for(var j=0; j<subkeys.length; j++){
                if(this.r[subkeys[j]+'-'+i]){
                    const current=this.r[subkeys[j]+'-'+i].validate();
                    if(!current.valid){
                        return current;
                    }
                    if(subkeys[j] != "reason"){
                        total += parseInt(current.value);
                    }
                }
            }
            if(total == 0){
                return {valid:false,value:"No items returned on row " + (i+1)};
            }
            if(total > options[i].quantity){
                return {valid:false,value:"Row " + (i+1) + " is attempting to return more items than drawn"};
            }
        }
        return {valid:true,value:options};
    }

    render=()=>{
        const {options}=this.props;
        const {page,startIndex,endIndex}=this.state;
        const maxPage = Math.ceil(options.length / this.pageLength);

        if(options.length == 0){
            return (
                <div className='list-placeholder'>
                    <b>No Items Available</b>
                </div>
            )
        }

        return (
            <div>
                <div className='list-table' style={{maxHeight:"none",fontSize:"14px",width:"1440px"}}>
                    <table>
                        <thead>
                            <tr>
                                <th className='remove left'/>
                                <th>Item</th>
                                <th style={{width:"80px",textAlign:"center"}}>Drawn</th>
                                <th style={{width:"80px"}}>Returned</th>
                                <th style={{width:"80px"}}>Missing</th>
                                <th style={{width:"80px"}}>Condemn</th>
                                <th style={{width:"150px",textAlign:"center"}}>Total</th>
                                <th style={{width:"200px"}} className='right'>Reason</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                options.map(
                                    (item,index)=>{
                                        if(index<startIndex || index>=endIndex){
                                            return null;
                                        }
                                        return (
                                            <tr key={index}>
                                                <td>
                                                    {index + 1}.
                                                </td>
                                                <td>{item.itemCode} - {item.itemName}</td>
                                                <td style={{textAlign:"center"}}>{item.quantity}</td>
                                                <td>
                                                    <Box ref={(ref)=>{this.r['return-'+index]=ref}}
                                                         values={{value:item.return}}
                                                         field="return"
                                                         label="Return"
                                                         index={index}
                                                         rules={{required:true,minValue:0}}
                                                         onChange={this.onChange}
                                                         />
                                                </td>
                                                <td>
                                                    <Box ref={(ref)=>{this.r['missing-'+index]=ref}}
                                                         values={{value:item.missing}}
                                                         field="missing"
                                                         label="Missing"
                                                         index={index}
                                                         rules={{required:true,minValue:0}}
                                                         onChange={this.onChange}
                                                         />
                                                </td>
                                                <td>
                                                    <Box ref={(ref)=>{this.r['condemned-'+index]=ref}}
                                                         values={{value:item.condemned}}
                                                         field="condemned"
                                                         label="Condemned"
                                                         index={index}
                                                         rules={{required:true,minValue:0}}
                                                         onChange={this.onChange}
                                                         />
                                                </td>
                                                <td style={{textAlign:"center"}}>{parseInt(item.return) + parseInt(item.missing) + parseInt(item.condemned)} {item.servingQuantifier}</td>
                                                <td>
                                                    {
                                                        (parseInt(item.missing) + parseInt(item.condemned) > 0)
                                                            ?
                                                            <Box ref={(ref)=>{this.r['reason-'+index]=ref}}
                                                                 values={{value:item.reason}}
                                                                 field="reason"
                                                                 label="Reason"
                                                                 index={index}
                                                                 rules={{required:true}}
                                                                 onChange={this.onChange}
                                                                 />
                                                            :
                                                            "-"
                                                    }
                                                </td>
                                            </tr>
                                        )
                                    }
                                )
                            }
                        </tbody>
                    </table>
                </div>
                {
                    (maxPage>1)
                        ?
                        <div style={{position:"relative",fontSize:"12px",margin:"30px auto"}}>
                            <PageSelector maxPage={maxPage}
                                        page={page}
                                        onChange={this.onChangePage}
                                        />
                        </div>
                        :
                        null
                }
            </div>
        )
    }
}

class CanDrawItem extends React.Component{
    r={};

    pageLength=10;

    state={
        page:1,
        startIndex:0,
        endIndex:this.pageLength,
    }

    onChangePage=(newPage)=>{
        const startIndex = (newPage-1) * this.pageLength;
        const endIndex = startIndex + this.pageLength;
        this.setState({page:newPage,startIndex:startIndex,endIndex:endIndex});
    }

    onSelectAll=(value)=>{
        let {options}=this.props;
        options=options.map((item)=>{
            item.selected=value && item.canTransfer;
            return item;
        });
        this.props.onChange(options);
    }

    onChange=(value,label,index)=>{
        let {options}=this.props;
        options[index].selected=value;
        this.props.onChange(options);
    }

    render=()=>{
        const {options}=this.props;
        const {page,startIndex,endIndex}=this.state;
        const maxPage = Math.ceil(options.length / this.pageLength);

        if(options.length == 0){
            return (
                <div className='list-placeholder'>
                    <b>No Items Available</b>
                </div>
            )
        }

        return (
            <div>
                <div className='list-table' style={{maxHeight:"none",fontSize:"14px"}}>
                    <table>
                        <thead>
                            <tr>
                                <th className='remove left'>
                                    <Checkbox values={{
                                                value:(options.filter((item)=>{return item.selected}).length == options.filter((item)=>{return item.canTransfer}).length),
                                                
                                            }}
                                            onChange={this.onSelectAll}
                                            label="Select All"
                                            />
                                </th>
                                <th>Item</th>
                                <th style={{width:"150px"}}>Quantifier</th>
                                <th className='right'>Remarks</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                options.map(
                                    (item,index)=>{
                                        if(index<startIndex || index>=endIndex){
                                            return null;
                                        }
                                        return (
                                            <tr key={index}>
                                                <td>
                                                    <Checkbox values={{
                                                                value:item.selected,
                                                                enabled:item.canTransfer==true
                                                            }}
                                                            index={index}
                                                            label="Selected"
                                                            field="selected"
                                                            onChange={this.onChange}
                                                            />
                                                </td>
                                                <td>{item.itemCode} - {item.itemName}</td>
                                                <td>{item.servingQuantifier}</td>
                                                <td>{(item.cannotTransferReason) ? <span className='text-negative'>{item.cannotTransferReason}</span> : "-"}</td>
                                            </tr>
                                        )
                                    }
                                )
                            }
                        </tbody>
                    </table>
                </div>
                {
                    (maxPage>1)
                        ?
                        <div style={{position:"relative",fontSize:"12px",margin:"30px auto"}}>
                            <PageSelector maxPage={maxPage}
                                        page={page}
                                        onChange={this.onChangePage}
                                        />
                        </div>
                        :
                        null
                }
            </div>
        )
    }
}

class ConfirmDrawItem extends React.Component{
    r={};

    pageLength=10;

    state={
        page:1,
        startIndex:0,
        endIndex:this.pageLength,
    }

    onChangePage=(newPage)=>{
        const startIndex = (newPage-1) * this.pageLength;
        const endIndex = startIndex + this.pageLength;
        this.setState({page:newPage,startIndex:startIndex,endIndex:endIndex});
    }

    onChange=(value,label,index)=>{
        let {options}=this.props;
        options[index][label]=value;
        this.props.onChange(options);
    }

    onRemoveInterest=(index)=>{
        let {options}=this.props;
        options.splice(index,1);
        this.props.onChange(options);
    }

    validate=()=>{
        const {options}=this.props;
        const keys =['returnDate','drawReason',"quantity"];
        for(var i=0; i<options.length; i++){
            for(var j=0; j<keys.length; j++){
                if(this.r[keys[j]+"-"+i]){
                    const current=this.r[keys[j]+"-"+i].validate();
                    if(!current.valid){
                        return current;
                    }
                }
            }
        }
        return {valid:true,value:options};
    }

    render=()=>{
        const {options}=this.props;
        const {page,startIndex,endIndex}=this.state;
        const maxPage = Math.ceil(options.length / this.pageLength);

        if(options.length == 0){
            return (
                <div className='list-placeholder'>
                    <b>No Items Available</b>
                </div>
            )
        }

        return (
            <div>
                <div className='list-table short-padding' style={{maxHeight:"none",fontSize:"14px",width:"1440px"}}>
                    <table>
                        <thead>
                            <tr>
                                <th className='remove left'/>
                                <th>Item</th>
                                <th style={{width:"200px"}}>Return Date</th>
                                <th style={{width:"200px"}}>Draw Reason</th>
                                <th style={{width:"50px"}}>Quantity</th>
                                <th className='right' style={{width:"100px"}}/>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                options.map(
                                    (item,index)=>{
                                        if(index<startIndex || index>=endIndex){
                                            return null;
                                        }
                                        return (
                                            <tr key={index}>
                                                <td className='remove'>
                                                    <MiniMinusButton index={index}
                                                                     onClick={this.onRemoveInterest}
                                                                     />
                                                </td>
                                                <td>{item.itemCode} - {item.itemName}</td>
                                                <td>
                                                    {
                                                        (item.drawLogic == "Provide Reason/Return Date")
                                                            ?
                                                            <Date ref={(ref)=>{this.r['returnDate-'+index]=ref}}
                                                                  label="Return Date"
                                                                  field="returnDate"
                                                                  values={{value:item.returnDate}}
                                                                  index={index}
                                                                  onChange={this.onChange}
                                                                  range={[1,5]}
                                                                  rules={{required:true}}
                                                                  />
                                                            :
                                                            "-"
                                                    }
                                                </td>
                                                <td>
                                                    <Box ref={(ref)=>{this.r['drawReason-'+index]=ref}}
                                                         label="Draw Reason"
                                                         field="drawReason"
                                                         values={{value:item.drawReason}}
                                                         index={index}
                                                         onChange={this.onChange}
                                                         rules={{
                                                            required:(item.drawLogic=="Provide Reason/Return Date"),
                                                            placeholder:(item.drawLogic == "Provide Reason/Return Date") ? "" : "Optional"
                                                         }}
                                                         />
                                                </td>
                                                <td>
                                                    <Box ref={(ref)=>{this.r['quantity-'+index]=ref}}
                                                         label="Quantity"
                                                         field="quantity"
                                                         values={{value:item.quantity}}
                                                         type="number"
                                                         index={index}
                                                         onChange={this.onChange}
                                                         rules={{required:true,minValue:1}}
                                                         />
                                                </td>
                                                <td>{item.servingQuantifier}</td>
                                            </tr>
                                        )
                                    }
                                )
                            }
                        </tbody>
                    </table>
                </div>
                {
                    (maxPage>1)
                        ?
                        <div style={{position:"relative",fontSize:"12px",margin:"30px auto"}}>
                            <PageSelector maxPage={maxPage}
                                        page={page}
                                        onChange={this.onChangePage}
                                        />
                        </div>
                        :
                        null
                }
            </div>
        )
    }
}

class DisposeItem extends React.Component{
    r={};

    settings={
        addType:0,
        addURL:"/api/dispose-store-items",
    }

    state={
        step:"view",
        condemnedItems:[],
        interest:[],
    }

    show=(show)=>{
        this.r[this.props.reference].show(show);
        if(!show){
            this.setState({error:"",condemnedItems:[],confirmDisclaimer:false});
        }
        else{
            this.getCondemnedItems();
        }
    }

    onCancel=()=>{
        this.props.onToggleForm(this.props.reference,false);
    }

    onConfirmInterest=()=>{
        const {condemnedItems}=this.state;
        let interest=condemnedItems.filter((item)=>{
            return item.selected
        }).map((item)=>{
            return item;
        });
        if(interest.length > 0){
            this.setState({step:"confirm",interest:interest,error:""});
        }
        else{
            this.setState({error:"Please select at least 1 item to dispose of"});
        }
        
    }

    onComplete=()=>{
        this.setState({
            entryData:{},
            step:"view",
            confirmDisclaimer:false,
        });
    }

    getCondemnedItems=async ()=>{
        try{
            const response=await u.postAsync({
                url:"/api/get-condemned-items",
            })
            this.setState({condemnedItems:response.data,loading:false});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error,loading:false});
        }
    }

    diposeCondemnedItems=async()=>{
        this.r[this.props.reference].onValidated({items:this.state.interest});
    }

    render=()=>{
        const {loading,loadText,step,condemnedItems,interest,
               confirmDisclaimer}=this.state;

        return (
            <AddListItem ref={(ref)=>{this.r[this.props.reference]=ref}}
                         reference={this.props.reference}
                         settings={this.settings}
                         onComplete={this.onComplete}
                         uploadAsJson={true}
                         onToggleForm={this.props.onToggleForm}
                         action="disposed of"
                         >
                <div className='segment-content'>
                    <LoadGraphic active={loading} text={loadText}/>
                    <Step active={step=="view"}>
                        <h3>Select the following condemned items to dispose</h3>

                        <ChooseDisposeItem options={condemnedItems}
                                           onChange={(value)=>{this.setState({condemnedItems:value})}}
                                           />

                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={this.onCancel}>Cancel</Button>
                            <Button onClick={this.onConfirmInterest}>Confirm</Button>
                        </div>
                    </Step>

                    <Step active={step=="confirm"}>
                        <h3 className='text-negative'>Confirm disposal of following items</h3>
                        
                        <ConfirmDisposeItem options={interest}
                                            onChange={(value)=>{this.setState({interest:value})}}
                                            />

                        <div style={{margin:"20px auto"}}>
                            <Checkbox values={{value:confirmDisclaimer}}
                                      onChange={(value)=>{this.setState({confirmDisclaimer:value})}}/>
                            
                            <span style={{marginLeft:"10px"}} className='segment-note'>
                                Note. All condemned quantities of the selected items will be reduced to 0
                            </span>
                        </div>

                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={this.onCancel}>Cancel</Button>
                            <Button enabled={(confirmDisclaimer==true)} onClick={this.diposeCondemnedItems}>Confirm</Button>
                        </div>
                    </Step>
                </div>
            </AddListItem>
        )
    }
}

class ChooseDisposeItem extends React.Component{
    r={};

    pageLength=10;

    state={
        page:1,
        startIndex:0,
        endIndex:this.pageLength,
    }

    onChangePage=(newPage)=>{
        const startIndex = (newPage-1) * this.pageLength;
        const endIndex = startIndex + this.pageLength;
        this.setState({page:newPage,startIndex:startIndex,endIndex:endIndex});
    }

    onSelectAll=(value)=>{
        let {options}=this.props;
        options=options.map((item)=>{
            item.selected=value;
            return item;
        });
        this.props.onChange(options);
    }

    onChange=(value,label,index)=>{
        let {options}=this.props;
        options[index].selected=value;
        this.props.onChange(options);
    }

    render=()=>{
        const {options}=this.props;
        const {page,startIndex,endIndex}=this.state;
        const maxPage = Math.ceil(options.length / this.pageLength);

        if(options.length == 0){
            return (
                <div className='list-placeholder'>
                    <b>No Items Available</b>
                </div>
            )
        }

        return (
            <div>
                <div className='list-table' style={{maxHeight:"none",fontSize:"14px"}}>
                    <table>
                        <thead>
                            <tr>
                                <th className='remove left'>
                                    <Checkbox values={{
                                                value:(options.filter((item)=>{return item.selected}).length == options.length)
                                              }}
                                              onChange={this.onSelectAll}
                                              label="Select All"
                                              />
                                </th>
                                <th>Item</th>
                                <th className='right' style={{width:"150px"}}>Condemned</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                options.map(
                                    (item,index)=>{
                                        if(index<startIndex || index>=endIndex){
                                            return null;
                                        }
                                        return (
                                            <tr key={index}>
                                                <td>
                                                    <Checkbox values={{
                                                                value:item.selected,
                                                              }}
                                                              index={index}
                                                              label="Selected"
                                                              field="selected"
                                                              onChange={this.onChange}
                                                              />
                                                </td>
                                                <td>{item.itemCode} - {item.itemName}</td>
                                                <td>{item.condemnedQuantity} {item.servingQuantifier}</td>
                                            </tr>
                                        )
                                    }
                                )
                            }
                        </tbody>
                    </table>
                </div>
                {
                    (maxPage>1)
                        ?
                        <div style={{position:"relative",fontSize:"12px",margin:"30px auto"}}>
                            <PageSelector maxPage={maxPage}
                                        page={page}
                                        onChange={this.onChangePage}
                                        />
                        </div>
                        :
                        null
                }
            </div>
        )
    }
}

class ConfirmDisposeItem extends React.Component{
    r={};

    pageLength=10;

    state={
        page:1,
        startIndex:0,
        endIndex:this.pageLength,
    }

    onChangePage=(newPage)=>{
        const startIndex = (newPage-1) * this.pageLength;
        const endIndex = startIndex + this.pageLength;
        this.setState({page:newPage,startIndex:startIndex,endIndex:endIndex});
    }

    onChange=(value,label,index)=>{
        let {options}=this.props;
        options[index][label]=value;
        this.props.onChange(options);
    }

    onRemoveInterest=(index)=>{
        let {options}=this.props;
        options.splice(index,1);
        this.props.onChange(options);
    }

    validate=()=>{
        const {options}=this.props;
        const keys =['returnDate','drawReason',"quantity"];
        for(var i=0; i<options.length; i++){
            for(var j=0; j<keys.length; j++){
                if(this.r[keys[j]+"-"+i]){
                    const current=this.r[keys[j]+"-"+i].validate();
                    if(!current.valid){
                        return current;
                    }
                }
            }
        }
        return {valid:true,value:options};
    }

    render=()=>{
        const {options}=this.props;
        const {page,startIndex,endIndex}=this.state;
        const maxPage = Math.ceil(options.length / this.pageLength);

        if(options.length == 0){
            return (
                <div className='list-placeholder'>
                    <b>No Items Available</b>
                </div>
            )
        }

        return (
            <div>
                <div className='list-table short-padding' style={{maxHeight:"none",fontSize:"14px"}}>
                    <table>
                        <thead>
                            <tr>
                                <th className='remove left'/>
                                <th>Item</th>
                                <th className='right' style={{width:"150px"}}>Condemned</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                options.map(
                                    (item,index)=>{
                                        if(index<startIndex || index>=endIndex){
                                            return null;
                                        }
                                        return (
                                            <tr key={index}>
                                                <td className='remove'>{index+1}.</td>
                                                <td>{item.itemCode} - {item.itemName}</td>
                                                <td>{item.condemnedQuantity} {item.servingQuantifier}</td>
                                            </tr>
                                        )
                                    }
                                )
                            }
                        </tbody>
                    </table>
                </div>
                {
                    (maxPage>1)
                        ?
                        <div style={{position:"relative",fontSize:"12px",margin:"30px auto"}}>
                            <PageSelector maxPage={maxPage}
                                        page={page}
                                        onChange={this.onChangePage}
                                        />
                        </div>
                        :
                        null
                }
            </div>
        )
    }
}